import "./AbTestStyles.css";

const AbTestDataBox = ({ type, header, content, className = "" }) => {
  let containerClassName = "abtest-container-";
  let headerClassName = "fs-14 fw-400 lh-20 ";
  let contentClassName = "fs-16 fw-500 lh-20 ";

  const typeStyles = {
    active: { container: "1", header: "fc-blue", content: "fc-black" },
    faded: { container: "1", header: "fc-grey", content: "fc-grey" },
    grey: { container: "2", header: "fc-grey", content: "fc-grey" },
    grey2: { container: "2", header: "fc-grey2", content: "fc-black" },
  };

  if (typeStyles[type]) {
    containerClassName += typeStyles[type].container;
    headerClassName += typeStyles[type].header;
    contentClassName += typeStyles[type].content;
  } else {
    return;
  }

  if (className) {
    containerClassName += ` ${className}`;
  }

  return (
    <div className={containerClassName}>
      <div className={headerClassName}>{header}</div>
      <div className={contentClassName}>{content}</div>
    </div>
  );
};

export default AbTestDataBox;
